import DashboardRouter from "./DashboardRouter";
import { Layout } from "antd";
import './index.scss';

export default (props) => {

  return (
    <Layout style={{ overflow: 'auto', padding: '18px' }}>
      <DashboardRouter {...props} />
    </Layout>
  )
}
